/* Visibility Mesh pricing and free scan pages (owner's mix, built 2026-10-10). Loaded with defer only by the sections
   vm-bp-pricing-main, vm-bp-scan-hero and vm-bp-scan-runforyou. A guard makes a second copy of the tag do nothing.
   1. The two questions on /pages/pricing mark the suggested ledger column and push pricing_chooser_result to the dataLayer,
      as the live chooser in assets/vm-pricing-editorial.js did. Without JavaScript every column stays readable and the phone
      column pills still work through CSS.
   2. The free scan bar posts to the engine exactly as snippets/vm-free-scan did (same endpoint, body, replies and analytics call).
   3. The "run it for you" form posts to the app proxy exactly as snippets/vm-run-for-you did, with the same fallback to /contact.
   Analytics clicks still come from assets/vm-home.js through the data-vm-event attributes in the markup. */
(function () {
  "use strict";
  if (window.__vmpsBound) return;
  window.__vmpsBound = true;

  /* ---------- 1. pricing: two questions, one marked column ---------- */
  (function () {
    var form = document.getElementById("vmps-ask");
    if (!form) return;
    /* outcome: which ledger section and which column it marks */
    var MAP = { app: ["app", 1], audit: ["web", 2], assessment: ["web", 5], other: ["web", 5], setup: ["services", 1] };
    var idle = document.getElementById("vmps-ask-idle");
    var go = document.getElementById("vmps-ask-go");
    function value(name) { var c = form.querySelector('input[name="' + name + '"]:checked'); return c ? c.value : null; }
    function outcome(who, platform) {
      if (!who || !platform) return null;
      if (who === "me") return platform === "shopify" ? "app" : "audit";
      if (who === "team") return "assessment";
      return platform === "other" ? "other" : "setup";
    }
    function update() {
      var o = outcome(value("vmps-who"), value("vmps-platform"));
      if (idle) idle.hidden = !!o;
      form.querySelectorAll("[data-ans]").forEach(function (el) { el.hidden = el.getAttribute("data-ans") !== o; });
      document.querySelectorAll(".vmps-lt .is-sug").forEach(function (el) { el.classList.remove("is-sug"); });
      if (go) go.hidden = !o;
      if (!o) return;
      var sec = document.getElementById(MAP[o][0]);
      var c = String(MAP[o][1]);
      if (sec) {
        sec.querySelectorAll('.vmps-lt [data-c="' + c + '"]').forEach(function (el) { el.classList.add("is-sug"); });
        var pill = sec.querySelector('.vmps-pick input[value="' + c + '"]');
        if (pill) pill.checked = true;
      }
      if (go) go.setAttribute("href", "#" + MAP[o][0]);
      try { if (window.dataLayer) window.dataLayer.push({ event: "pricing_chooser_result", vm_outcome: o }); } catch (e) {}
    }
    form.addEventListener("change", update);
    update();
  })();

  /* ---------- 2. free scan: the engine call, unchanged from snippets/vm-free-scan ---------- */
  (function () {
    var VM_ENGINE = "https://portal.visibilitymesh.com";
    var VM_UPSELL = "/pages/pricing";
    var root = document.getElementById("vmps-scanform");
    if (!root || root.dataset.vmBound) return;
    root.dataset.vmBound = "1";

    var btn = document.getElementById("vm-submit");
    var urlEl = document.getElementById("vm-url");
    var emailEl = document.getElementById("vm-email");
    var vertEl = document.getElementById("vm-vertical");
    var status = document.getElementById("vm-status");

    function show(msg, kind) {
      status.setAttribute("data-kind", kind || "info");
      status.innerHTML = msg;
    }
    function escapeHtml(v) { return String(v).replace(/[&<>"']/g, function (ch) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[ch]; }); }
    function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }
    function normUrl(v) {
      v = (v || "").trim();
      if (v && !/^https?:\/\//i.test(v)) v = "https://" + v;
      return v;
    }

    root.addEventListener("submit", function (ev) {
      ev.preventDefault();
      if (btn.disabled) return;
      var url = normUrl(urlEl && urlEl.value);
      var email = ((emailEl && emailEl.value) || "").trim();
      var vertical = (vertEl && vertEl.value) ? vertEl.value : null;

      if (!url) { show("Please enter your website URL.", "error"); urlEl.focus(); return; }
      try { new URL(url); } catch (e) { show("That website URL does not look right, so please check it.", "error"); urlEl.focus(); return; }
      if (!validEmail(email)) { show("Please enter a valid email address.", "error"); emailEl.focus(); return; }

      btn.disabled = true;
      var lbl = btn.textContent;
      btn.textContent = "Starting your scan";
      show("We are sending your scan to the engine now.", "info");

      var body = { target_url: url, email: email, tier: "T1" };
      if (vertical) body.vertical = vertical;

      fetch(VM_ENGINE + "/scans", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (d) { return { status: res.status, data: d }; });
      }).then(function (r) {
        var err = r.data && r.data.error;
        if (r.status === 202) {
          var rid = r.data && r.data.id;
          var watch = rid ? " <a href='/pages/results?id=" + encodeURIComponent(rid) + "'>Watch your results come in.</a>" : "";
          btn.textContent = "Scan started";
          /* First party signal for the VM pixel (Settings > Customer events > VM first-party): the lead moment. Host and scan id only, never the email. */
          try {
            var vmHost = ""; try { vmHost = new URL(url).hostname.replace(/^www\./, ""); } catch (e2) {}
            if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === "function") {
              Shopify.analytics.publish("vm_free_scan_submitted", { product_handle: vmHost.replace(/[^a-z0-9-]/g, "-"), product_title: vmHost, product_type: "free-scan", available: true });
            }
          } catch (e3) {}
          show("Your scan has started. We will email your scorecard to <strong>" + escapeHtml(email) + "</strong>, usually within minutes." + watch, "ok");
        } else if (r.status === 409 && err === "free_scan_used") {
          var eid = r.data && r.data.id;
          var view = eid ? "<a href='/pages/results?id=" + encodeURIComponent(eid) + "'>View your results.</a> " : "";
          show("You already ran a free scan on this email in the last 30 days. " + view + "When you are ready for the deep scan, <a href='" + VM_UPSELL + "'>see the plans</a>.", "ok");
          btn.disabled = false; btn.textContent = lbl;
        } else if (r.status === 429) {
          show("We are getting too many requests right now, so please try again a little later.", "error");
          btn.disabled = false; btn.textContent = lbl;
        } else if (r.status === 400) {
          show("Please check your website URL and email, and then try again.", "error");
          btn.disabled = false; btn.textContent = lbl;
        } else {
          show("Something went wrong while we started your scan, so please try again.", "error");
          btn.disabled = false; btn.textContent = lbl;
        }
      }).catch(function () {
        show("We could not reach the scan engine, so please try again in a moment.", "error");
        btn.disabled = false; btn.textContent = lbl;
      });
    });
  })();

  /* ---------- 3. run it for you: the app proxy call, unchanged from snippets/vm-run-for-you ---------- */
  (function () {
    var form = document.getElementById("vm-rfy-form");
    if (!form || form.dataset.vmBound) return;
    form.dataset.vmBound = "1";
    var msg = document.getElementById("vm-rfy-msg");
    var started = false;
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (started) return;
      var hp = form.querySelector('input[name="hp"]');
      if (hp && hp.value) return;
      var email = form.querySelector('input[name="contact[email]"]');
      var site = form.querySelector('input[name="contact[Website]"]');
      if (!email.value || !email.checkValidity() || !site.value || !site.checkValidity()) {
        msg.setAttribute("data-kind", "error");
        msg.textContent = "Please enter a full website address that starts with https:// and a valid email address.";
        return;
      }
      started = true;
      var btn = form.querySelector('button[type="submit"]');
      btn.disabled = true;
      var done = false;
      var native = function () { if (done) return; done = true; HTMLFormElement.prototype.submit.call(form); };
      var thanks = function () {
        if (done) return; done = true;
        msg.removeAttribute("data-kind");
        msg.textContent = "Thank you. We received your request and will reply within 1 business day.";
        btn.textContent = "Request sent";
        try { (window.dataLayer = window.dataLayer || []).push({ event: "run_for_you_submit", location: "free_scan" }); } catch (x) {}
      };
      var payload = {
        email: email.value,
        website: site.value,
        service: "managed",
        message: "Free scan page: please run the scan for me and send the findings.",
        page: window.location.pathname,
        hp: ""
      };
      setTimeout(native, 6000);
      if (!window.fetch) { native(); return; }
      fetch("/apps/visibility-mesh/quote", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify(payload),
        credentials: "same-origin",
        keepalive: true
      }).then(function (r) { if (r && r.ok) { thanks(); } else { native(); } }, native);
    });
  })();
})();
